import React from 'react';
export function Divider() {
  return <div className="flex items-center justify-center py-12 opacity-60" data-id="element-43">
      <div className="h-px w-24 bg-sage-light" data-id="element-44"></div>
      <span className="mx-4 text-2xl text-sage" data-id="element-45">🌿</span>
      <div className="h-px w-24 bg-sage-light" data-id="element-46"></div>
    </div>;
}